(() => {
  class NfcPurchaseAssurance extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.classList.add('is-visible');
          this.observer.disconnect();
          this.observer = null;
        },
        { threshold: 0.22 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  }

  if (!customElements.get('nfc-purchase-assurance')) {
    customElements.define('nfc-purchase-assurance', NfcPurchaseAssurance);
  }
})();
